import { render, staticRenderFns } from "./CaseManager.vue?vue&type=template&id=a54b1a94&"
import script from "./CaseManager.vue?vue&type=script&lang=js&"
export * from "./CaseManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports